// frontend/src/pages/PaymentHistory/styles.ts
// Color palette, type stacks, and shared style objects for the Payments page.

import type { CSSProperties } from "react";

export const FONT =
  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const MONO = "'SF Mono', Menlo, Consolas, monospace";

export const T = {
  ink: "#0E1A1A",
  slate: "#12262B",
  muted: "#556",
  line: "#F0F2F5",
  lineDark: "#E7EAF0",
  card: "#FFFFFF",
  cardAlt: "#FAFBFC",
  amberTint: "#FFF8E5",
  amberBorder: "#F0D775",
  amberInk: "#7A5B0F",
  amberDeep: "#5A430A",
} as const;

/**
 * Base table-header cell style. The original file wrapped this in a <Th> helper
 * component; we use a plain object instead and spread an inline override for
 * per-column alignment or width.
 */
export const thStyle: CSSProperties = {
  textAlign: "left",
  padding: "12px 16px",
  fontSize: 11.5,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.4,
  color: T.muted,
  background: T.cardAlt,
  borderBottom: "1px solid " + T.lineDark,
};